<script>
export default {
  name: 'reload-signin-message',
  template: '#reload-signin-template',
  computed: {
    loginLink: function () {
      const loginPage = '/login'
      const returnPage = window.location.pathname + window.location.search

      return `${loginPage}?ReturnUrl=${returnPage}`
    },
  },
}
</script>
